import { render } from "./MpkProjectMap.vue?vue&type=template&id=ba87defc&scoped=true"
import script from "./MpkProjectMap.vue?vue&type=script&lang=js"
export * from "./MpkProjectMap.vue?vue&type=script&lang=js"

import "./MpkProjectMap.vue?vue&type=style&index=0&id=ba87defc&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba87defc"]])

export default __exports__